// Dependencies
import React from 'react';

// import { EVENT_TYPE, FORM_NAME } from '../../../../../lib/analytics-constants';
import { RentVsBuyInput } from '../../../../../lib/utils';
import { LEGACY_FIELD_NAMES } from '../../../analytics-constants';
import MonthlyRent from '../monthly-rent';

const CONTROL_PANEL = 'controlPanel';

const analyticsPayload = {
  enabled: true,
  payload: {
    legacy: {
      formName: CONTROL_PANEL,
      fieldName: LEGACY_FIELD_NAMES.MONTHLY_RENT,
    },
    // bedrock: {
    //   eventType: EVENT_TYPE.HOME_RENT_UPDATED,
    //   form_name: FORM_NAME.RENT_VS_BUY_CALCULATOR,
    //   was_prefilled: true,
    //   page_number: null,
    //   total_pages: null,
    // },
  },
};
const MonthlyRentInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  className,
  fullWidth,
}) => {
  return (
    <MonthlyRent
      label={label}
      analytics={analyticsPayload}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default MonthlyRentInputWithAnalytics;
